export default "__VITE_ASSET__8abcec04__"